import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    language: 'en'
  },
  mutations: {
    toggleLanguage(state) {
      if (state.language === 'en') {
        return state.language = 'es';
      }

      state.language = 'en';
    },
    setLanguage(state, lang) {
      if (lang === 'es' || lang === 'en') {
        return state.language = lang;
      }
    }
  },
  actions: {
    toggleLanguage(context) {
      context.commit('toggleLanguage')
    },
    setLanguage({ commit }, lang) {
      commit('setLanguage', lang);
    }
  },
  getters: {
    language: state => {
      return state.language;
    }
  },
  modules: {
  }
})
